import type { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import ThemeProvider, { CarvanaTheme, createGlobalStyle } from '@carvana/theme';
import { CarvanaHeaderProvider } from '@carvana/header';
import Header from 'Helpers/Header';
import Footer from 'Helpers/Footer';
import Routes from './Routes';
import { Container, PageContainer } from './App.styles';

const GlobalStyle = createGlobalStyle(
  (process.env.NODE_ENV as 'development' | 'test' | 'prod') ?? 'test',
  `body, html, #root {
      height: 100%;
      background: ${CarvanaTheme.carvana.gray.background};
   }` as any
);

const Providers = ({ children }: { children?: ReactNode }) => (
  <BrowserRouter basename={process.env.CARVANA_APP_PUBLIC_PATH}>
    <ThemeProvider>
      <GlobalStyle />
      <CarvanaHeaderProvider>{children}</CarvanaHeaderProvider>
    </ThemeProvider>
  </BrowserRouter>
);

const App = () => (
  <Providers>
    <PageContainer>
      <Container>
        <Header />
        <Routes />
      </Container>
      <Footer />
    </PageContainer>
  </Providers>
);

export default App;
